import React from 'react';
import { connect } from 'react-redux';
import classes from './Extras.scss';

import seatsImage from './img/addon-seats.svg';
import mealsImage from './img/addon-meals.svg';
import baggageImage from './img/addon-baggage.svg';

import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import HeadingH4 from '../../UI/Headings/HeadingH4/HeadingH4';

import Media from 'react-media';
import * as uiActions from '../../../store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const extras = (props) =>  {
    return (
            <div>
                <ul className={classes.List}>
                    {
                        props.generalData && props.generalData.data.seats ? 
                        <li className={`${classes.ListItem} u-transitionAll300Ease`} onClick={() => { props.onToggleAddons('seats') }}>
                            <div className={classes.ListImage}>
                                <img src={seatsImage} alt='Seats'/>
                            </div>
                            <div className={classes.ListHeadingBox}>
                                <div className={classes.ListHeadingBoxInner}>
                                    <HeadingH3 size={16} weight="Regular" color="Dark">Seat</HeadingH3>
                                    <HeadingH4 size={13} weight="Regular" color="Light">Choose your seat</HeadingH4>
                                </div>
                            </div>
                            <div className={classes.ListButtonBox}>
                                <Media query="(max-width: 599px)">
                                    {matches =>
                                        matches ? <span className={`u-inlineBlock u-transformRotate270`}><FontAwesomeIcon icon="angle-down" color="#666" size="lg" /></span> : <span className={`u-textColorPrimary u-textUppercase u-fontSize13`}>SELECT</span> }
                                </Media>
                            </div>
                        </li> : null
                    }
                    {
                        props.generalData && props.generalData.data.baggage && JSON.parse(props.generalData.data.baggage.isbaggage) === true ? 
                        <li className={classes.ListItem} onClick={() => { props.onToggleAddons('baggage') }}>
                            <div className={classes.ListImage}>
                                <img src={baggageImage} alt='Baggage'/>
                            </div>
                            <div className={classes.ListHeadingBox}>
                                <div className={classes.ListHeadingBoxInner}>
                                    <HeadingH3 size={16} weight="Regular" color="Dark">Luggage</HeadingH3>
                                    <HeadingH4 size={13} weight="Regular" color="Light">Add extra luggage</HeadingH4>
                                </div>
                            </div>
                            <div className={classes.ListButtonBox}>
                                <Media query="(max-width: 599px)">
                                    {matches =>
                                        matches ? <span className={`u-inlineBlock u-transformRotate270`}><FontAwesomeIcon icon="angle-down" color="#666" size="lg" /></span> : <span className={`u-textColorPrimary u-textUppercase u-fontSize13`}>SELECT</span> }
                                </Media>
                            </div>
                        </li> : null
                    }
                    {
                        props.generalData && props.generalData.data.meals && JSON.parse(props.generalData.data.meals.isMeal) === true ? 
                        <li className={classes.ListItem} onClick={() => { props.onToggleAddons('meals') }}>
                            <div className={classes.ListImage}>
                                <img src={mealsImage} alt='Meals'/>
                            </div>
                            <div className={classes.ListHeadingBox}>
                                <div className={classes.ListHeadingBoxInner}>
                                    <HeadingH3 size={16} weight="Regular" color="Dark">Meals</HeadingH3>
                                    <HeadingH4 size={13} weight="Regular" color="Light">Select your meal</HeadingH4>
                                </div>
                            </div>
                            <div className={classes.ListButtonBox}>
                                <Media query="(max-width: 599px)">
                                    {matches =>
                                        matches ? <span className={`u-inlineBlock u-transformRotate270`}><FontAwesomeIcon icon="angle-down" color="#666" size="lg" /></span> : <span className={`u-textColorPrimary u-textUppercase u-fontSize13`}>SELECT</span> }
                                </Media>
                            </div>
                        </li> : null
                    }
                </ul>
            </div>
    );
}

const mapStateToProps = state => {
    return {
        generalData: state.farePrice.generalData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleAddons: (view) => dispatch(uiActions.toggleAddons(view)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(extras);


// WEBPACK FOOTER //
// ./src/components/Addons/Extras/Extras.js